import styled from '@emotion/styled';

import COLOR from '../../../../shared/constant/colorset';
import { DeactivationProps, DeliveryType } from '../../../../shared/interfaces';
import { isPC } from '../../../../../util/window/getDevice';

const Delivery: Record<DeliveryType, string> = {
  direct: '샛별배송',
  indirect: '낮배송',
  disable: '배송불가',
};

const colors: Record<DeliveryType, string> = {
  direct: COLOR.kurlyPurple,
  indirect: COLOR.kurlyGray600,
  disable: COLOR.disabled,
};

const DeliveryBadge = styled.span<{ type: DeliveryType; }>(({ type }) => `
  color: ${colors[type]};
  font-size: ${isPC ? '14px;' : '12px;'}
`);

const RegionNotice = styled.span`
  margin-left: 5px;
  color: ${COLOR.kurlyGray600};
  font-size: ${isPC ? '14px;' : '12px;'}
`;

interface Props{
  className?: string;
  type: DeliveryType;
  deactivation?: DeactivationProps;
  deactivationViewType?: 'basic' | 'hide';
}

function DeactivationNotice({
  deactivation,
  deactivationViewType,
}: Pick<Props, 'deactivation' | 'deactivationViewType'>) {
  if (!deactivation || deactivation.startAt === null || deactivation.endAt === null) {
    return null;
  }

  if (deactivationViewType === 'basic') {
    return (
      <RegionNotice>
        {deactivation.startAt.slice(0, 2)}
        시~
        {deactivation.endAt.slice(0, 2)}
        시 낮배송
      </RegionNotice>
    );
  }

  return (
    <RegionNotice>
      {deactivation.startAt.slice(0, 2)}
      시 이후 낮배송
    </RegionNotice>
  );
}

export default function AddressDeliveryType({
  type,
  deactivation,
  className,
  deactivationViewType = 'basic',
}: Props) {
  return (
    <div className={className}>
      <DeliveryBadge type={type}>{Delivery[type]}</DeliveryBadge>
      <DeactivationNotice
        deactivation={deactivation}
        deactivationViewType={deactivationViewType}
      />
    </div>
  );
}
